import Client from '../../websocket';
import { Loggy } from '../../loggy';
import Channel from './channel';

export default class PubSub {
    client: Client;

    channels: { [name: string]: Channel };

    log: Loggy;

    constructor(client: Client) {
        this.client = client;

        this.log = client.log;
        this.channels = {};
    }

    handleClose() {
        for (const [, value] of Object.entries(this.channels)) {
            value.unsubscribeAll();
        }
        this.channels = {};
    }

    subscribe(key: string): Channel {
        if (!this.channels[key]) {
            this.client.sendObject({
                key: 'pubsub.subscribe',
                data: {
                    key: key,
                },
            });
            let channel = new Channel(this, key);
            this.channels[key] = channel;
            return channel;
        } else {
            return this.channels[key];
        }
    }

    handleRequest(data: any) {
        if (data.channel) {
            let channel = this.channels[data.channel];
            if (channel != null) {
                channel.handleData(data);
            }
        }
    }
}
